var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 21.25V2.75H16V5.4C16 5.73137 16.2686 6 16.6 6H19.25V12C19.25 12.4142 19.5858 12.75 20 12.75C20.4142 12.75 20.75 12.4142 20.75 12V5.74853C20.75 5.39049 20.6078 5.04711 20.3546 4.79393L17.2061 1.64541C16.9529 1.39223 16.6095 1.25 16.2515 1.25H4.6C3.85442 1.25 3.25 1.85441 3.25 2.6V21.4C3.25 22.1456 3.85441 22.75 4.6 22.75H11C11.4142 22.75 11.75 22.4142 11.75 22C11.75 21.5858 11.4142 21.25 11 21.25H4.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.25C7.58579 5.25 7.25 5.58579 7.25 6C7.25 6.41421 7.58579 6.75 8 6.75H12C12.4142 6.75 12.75 6.41421 12.75 6C12.75 5.58579 12.4142 5.25 12 5.25H8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.25C7.58579 9.25 7.25 9.58579 7.25 10C7.25 10.4142 7.58579 10.75 8 10.75H16C16.4142 10.75 16.75 10.4142 16.75 10C16.75 9.58579 16.4142 9.25 16 9.25H8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75H11C11.4142 14.75 11.75 14.4142 11.75 14C11.75 13.5858 11.4142 13.25 11 13.25H8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4636 14.8657C18.0765 14.0448 16.9235 14.0448 16.5364 14.8657L15.7975 16.4322L14.1591 16.6829C13.2483 16.8222 12.9769 17.9219 13.5611 18.5175L14.7658 19.7455L14.4801 21.4887C14.3474 22.2985 15.1924 23.0865 16.0436 22.618L17.5 21.8164L18.9564 22.618C19.8076 23.0865 20.6526 22.2985 20.5199 21.4887L20.2342 19.7455L21.4389 18.5175C22.0231 17.9219 21.7517 16.8222 20.8409 16.6829L19.2025 16.4322L18.4636 14.8657ZM16.9839 17.4332L17.5 16.3389L18.0161 17.4332C18.1225 17.6589 18.3343 17.8169 18.581 17.8546L19.8043 18.0418L18.8972 18.9665C18.7299 19.1371 18.6538 19.3772 18.6925 19.613L18.8992 20.8743L17.8616 20.3033C17.6365 20.1793 17.3635 20.1793 17.1384 20.3033L16.1008 20.8743L16.3075 19.613C16.3462 19.3772 16.2701 19.1371 16.1028 18.9665L15.1957 18.0418L16.419 17.8546C16.6657 17.8169 16.8775 17.6589 16.9839 17.4332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageStar);
export default __webpack_public_path__ + "static/media/page-star.518c29cd.svg";
export { ForwardRef as ReactComponent };